import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Img from "gatsby-image"
import { Link } from 'gatsby';
import { AsideContainer } from './aside.css';

const Aside = ({ data, children }) => (
  <AsideContainer className="sidebar">
    <div className="widget">
      <h4 className="widget-title">About Me</h4>
      <div className="about-widget">
        <Img
          fluid={data.asideJson.gallery[0].image ? data.asideJson.gallery[0].image.childImageSharp.fluid : {}}
          alt="Aniruddha" 
          className="about-round"
        />
        <p>{data.asideJson.intro}... </p>
      </div>
    </div>
    <div className="widget">
      <h4 className="widget-title">Subscribe &amp; Follow</h4>
      <div className="social-widget">
        {data.asideJson.links.map((item, i) => (
          <a href={item.link} target="_blank" rel="noreferrer" key={i}><i className={item.for}>&nbsp;</i></a>
        ))}
        <a href="http://aniruddha-blog.netlify.com/" target="_blank" rel="noreferrer"><i className="fa fa-heart">&nbsp;</i></a>
      </div>
    </div>
  </AsideContainer>
);

Aside.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.object.isRequired,
};

const AsideWithQuery = props => (
  <StaticQuery
    query={graphql`
        query AsideConfigQuery {
          asideJson {
            intro
            links {
              for
              link
            }
            title
            gallery {
              image {
                childImageSharp {
                  fluid(maxHeight: 300, maxWidth: 300) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
    `}
    render={data => <Aside data={data} {...props} />}
  />
);

AsideWithQuery.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AsideWithQuery;
